package com.dignicate.web.data

import com.dignicate.web.data.content.AboutContentDto
import com.dignicate.web.data.content.CompanyContentDto
import com.dignicate.web.data.content.HeroContentDto
import com.dignicate.web.data.content.ProductInfoDto
import com.dignicate.web.data.content.TechnologyAreaDto
import com.dignicate.web.data.content.ValueStatementDto
import com.dignicate.web.data.content.static.home.AboutContentSource
import com.dignicate.web.data.content.static.home.HeroContentSource
import com.dignicate.web.data.content.static.home.ProductsContentSource
import com.dignicate.web.data.content.static.home.TechnologiesContentSource
import com.dignicate.web.data.content.static.home.ValuesContentSource
import com.dignicate.web.data.content.static.legal.PrivacyPolicyContentSource
import com.dignicate.web.data.content.static.legal.TermsContentSource
import com.dignicate.web.data.content.static.shared.CompanyContentSource
import com.dignicate.web.data.content.static.shared.UiTextContentSource
import com.dignicate.web.domain.Language

class StaticSiteContentSource {

    private val heroContentSource = HeroContentSource()
    private val aboutContentSource = AboutContentSource()
    private val technologiesContentSource = TechnologiesContentSource()
    private val productsContentSource = ProductsContentSource()
    private val valuesContentSource = ValuesContentSource()
    private val companyContentSource = CompanyContentSource()
    private val privacyPolicyContentSource = PrivacyPolicyContentSource()
    private val termsContentSource = TermsContentSource()

    override fun toString(): String = "StaticSiteContentSource"

    fun hero(): HeroContentDto = heroContentSource.hero()

    fun about(): AboutContentDto = aboutContentSource.about()

    fun technologies(): List<TechnologyAreaDto> = technologiesContentSource.technologies()

    fun products(): List<ProductInfoDto> = productsContentSource.products()

    fun values(): List<ValueStatementDto> = valuesContentSource.values()

    fun company(): CompanyContentDto = companyContentSource.company()

    fun getPrivacyPolicyMarkdown(): String = privacyPolicyContentSource.getPrivacyPolicyMarkdown()

    fun getTermsMarkdown(): String = termsContentSource.getTermsMarkdown()

    companion object {
        fun aboutTitle(lang: Language): String = UiTextContentSource.aboutTitle(lang)

        fun servicesTitle(lang: Language): String = UiTextContentSource.servicesTitle(lang)

        fun servicesDescription(lang: Language): String = UiTextContentSource.servicesDescription(lang)

        fun productsTitle(lang: Language): String = UiTextContentSource.productsTitle(lang)

        fun productsDescription(lang: Language): String = UiTextContentSource.productsDescription(lang)

        fun valuesTitle(lang: Language): String = UiTextContentSource.valuesTitle(lang)

        fun valuesDescription(lang: Language): String = UiTextContentSource.valuesDescription(lang)

        fun languageLabel(lang: Language): String = UiTextContentSource.languageLabel(lang)

        fun languageOptionSystem(lang: Language): String = UiTextContentSource.languageOptionSystem(lang)

        fun languageOptionJa(lang: Language): String = UiTextContentSource.languageOptionJa(lang)

        fun languageOptionEn(lang: Language): String = UiTextContentSource.languageOptionEn(lang)

        fun themeLabel(lang: Language): String = UiTextContentSource.themeLabel(lang)

        fun themeOptionSystem(lang: Language): String = UiTextContentSource.themeOptionSystem(lang)

        fun themeOptionLight(lang: Language): String = UiTextContentSource.themeOptionLight(lang)

        fun themeOptionDark(lang: Language): String = UiTextContentSource.themeOptionDark(lang)
    }
}
